import React from 'react';
import { useGuestPageContentRedesign } from '@apps/guest/hooks/useGuestPageContentRedesign';
import { ScheduleListV2 } from './ScheduleListV2';
import type { ScheduleListProps } from './ScheduleListV1';
import { ScheduleListV1 } from './ScheduleListV1';

const ScheduleList = React.forwardRef<HTMLDivElement, ScheduleListProps>((props, ref) => {
  const { enabled: isGuestPageContentRedesignEnabled } = useGuestPageContentRedesign();

  return isGuestPageContentRedesignEnabled ? (
    <ScheduleListV2
      {...props}
      ref={ref}
    />
  ) : (
    <ScheduleListV1
      {...props}
      ref={ref}
    />
  );
});

ScheduleList.displayName = 'ScheduleList';

export { ScheduleList };
